module.exports = __webpack_public_path__ + "static/media/espiga_pastelera.ca1dd673.png";